import { Checkbox, cn } from '@nextui-org/react';

export type SelectAllCheckState = 'all' | 'some' | 'none';

export function getSelectAllCheckState(
  selectedCount: number,
  totalCount: number
): SelectAllCheckState {
  if (totalCount === 0 || selectedCount === 0) {
    return 'none';
  }

  if (selectedCount === totalCount) {
    return 'all';
  }

  return 'some';
}

interface SelectAllCheckboxProps {
  state: SelectAllCheckState;
  className?: string;
}

/** Matches NextUI Table row selection checkbox styling (read-only display). */
export function SelectAllCheckbox({
  state,
  className,
}: SelectAllCheckboxProps) {
  return (
    <Checkbox
      aria-hidden
      isReadOnly
      disableAnimation
      isSelected={state === 'all'}
      isIndeterminate={state === 'some'}
      classNames={{
        base: cn(
          'pointer-events-none m-0 max-w-none shrink-0 items-center pl-0',
          className
        ),
        wrapper: 'm-0 before:border-default after:bg-primary',
        icon: 'text-primary-foreground',
        label: 'hidden',
      }}
    />
  );
}
